module.exports = __webpack_public_path__ + "static/media/screenshot-5.0053490c.png";